import { createClient } from '@/shared/api';
import type { EventCountsQuery, EventCountsQueryVariables } from '@/shared/api';
import EVENT_COUNTS_QUERY from '../queries/eventCounts';

/**
 * Loads per-study event counts for the supplied study identifiers. Runs EVENT_COUNTS_QUERY and throws the raw eventCounts.message string when isSuccess is false, otherwise returning the eventCounts payload.
 *
 * @param studyIds - Identifiers of the studies to count events for.
 * @returns The event counts payload.
 */
const fetchEventCounts = async (studyIds: any) => {
  const client = createClient();
  const results = await client.query<EventCountsQuery, EventCountsQueryVariables>({
    query: EVENT_COUNTS_QUERY,
    variables: { studyIds },
  });
  const { data } = results;
  const { eventCounts } = data;
  if (!eventCounts || !eventCounts.isSuccess) {
    throw eventCounts?.message;
  }
  return eventCounts;
};

export default fetchEventCounts;
